// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.menu-bg[data-v-33ec43fc] {\n  background-color: #22837c;\n}\n", ""]);
// Exports
module.exports = exports;
